import { ESecondaryItemType, SecondaryItem } from "@similarweb/ui-components";

import { isHidden, isLocked } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import type { INavItem } from "app/components/sidebar3/types";

const standaloneSecondaryItem: INavItem["itemComponent"] = (props) => (
    <SecondaryItem
        {...props}
        itemType={ESecondaryItemType.Standalone}
    />
);

export const aiResearchNavObj = (): { navList: INavItem[] } => ({
    navList: [
        {
            title: "ai.research.sidebar.brand_research.title",
            name: "brandResearch",
            state: "airesearch.brandResearch.report",
            itemComponent: standaloneSecondaryItem,
            itemType: ESecondaryItemType.Standalone,
            isLocked: isLocked(swSettings.components.AIResearch),
            hidden: isHidden(swSettings.components.AIResearch),
        },
        {
            title: "ai.research.sidebar.industry_research.title",
            name: "industryResearch",
            state: "airesearch.industryResearch.report",
            itemComponent: standaloneSecondaryItem,
            itemType: ESecondaryItemType.Standalone,
            isLocked: isLocked(swSettings.components.AIResearch),
            hidden: isHidden(swSettings.components.AIResearch),
        },
    ],
});
